import type { Platform } from "@bandstand/core/Platform";

import { BrowserStorage } from "./storage/BrowserStorage";

/**
 * The platform the app runs on. The desktop app puts its own on the page as `bandstandPlatform`, with the library in a
 * folder on disk; in a browser, the library lives in the browser, and nothing changes it outside the app.
 */
export function currentPlatform(): Platform {
    const desktop = (window as { bandstandPlatform?: Platform }).bandstandPlatform;

    return desktop ?? { storage: new BrowserStorage(), onLibraryChange: () => () => {} };
}
